import { MobIconButton } from '../../components/mob';
import { useCurrentRouteRefresh } from './useCurrentRouteRefresh';

export function HeaderRefreshButton() {
  const { available, isRefreshing, refresh } = useCurrentRouteRefresh();
  if (!available) return null;

  return (
    <MobIconButton
      ariaLabel={isRefreshing ? 'Refreshing' : 'Refresh'}
      spinning={isRefreshing}
      onClick={refresh}
    >
      <svg viewBox="0 0 24 24">
        <path d="M21 12a9 9 0 0 1-15.5 6.4M3 12a9 9 0 0 1 15.5-6.4" />
        <polyline points="21 3 21 9 15 9" />
        <polyline points="3 21 3 15 9 15" />
      </svg>
    </MobIconButton>
  );
}
